<template>
  <div class="container">
    <div class="comments">
      <div>
        <span class="bold">{{ $t('weekly.notes') }}：</span>
        <span>{{ weeklyDetail.remarks }}</span>
      </div>
      <a-divider />
      <Loading v-if="queryLoading" />
      <comment-item
        v-for="comment in comments"
        :key="comment.id"
        :comment="comment"
        @delete="getComments"
      />
      <a-empty v-if="!queryLoading && !comments.length" />
    </div>
    <div class="comment">
      <a-textarea
        v-model:value="comment"
        :placeholder="$t('weekly.placeholder')"
        :auto-size="{ minRows: 1 }"
      />
      <a-button
        type="primary"
        :loading="saveLoading"
        @click="save"
      >
        {{ $t('shared.editDialog.ok') }}
      </a-button>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import CommentItem from './CommentItem.vue'
import { addWeeklyComment, getWeeklyComments } from '@/api/weekly.js'
import Loading from '@/components/Loading.vue'
import { message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  weeklyDetail: {
    type: Object,
    default: () => {}
  }
})

const { t } = useI18n()
const comment = ref('')
const saveLoading = ref(false)
const queryLoading = ref(false)

// 查询评论
const comments = ref([])
const getComments = () => {
  queryLoading.value = true
  getWeeklyComments(props.weeklyDetail.id).then(res => {
    comments.value = res || []
  }).finally(() => {
    queryLoading.value = false
  })
}
getComments()

// 添加评论
const save = () => {
  saveLoading.value = true
  const params = {
    weekly_id: props.weeklyDetail.id,
    content: comment.value
  }
  addWeeklyComment(params).then(res => {
    getComments()
    comment.value = ''
    message.success(t('okr.comment.sentMessage'))
  }).finally(() => {
    saveLoading.value = false
  })
}
</script>
<style lang="less" scoped>
.container {
  // display: flex;
  height: 100%;
}
.comments {
  // flex: 1;
  padding: 24px;
  padding-bottom: 60px;
}
.comment{
  position: absolute;
  background: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px;
}

.bold {
  font-weight: bolder;
}

:deep(.ant-divider-horizontal) {
  margin: 12px 0;
}
</style>
